(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductListTabs(root) {
      if (!root || root.dataset.productListTabsBound === 'true') return;
      root.dataset.productListTabsBound = 'true';
      const tablist = root.querySelector('[role="tablist"]');
      if (!tablist) return;
      const tabs = Array.from(tablist.querySelectorAll('[role="tab"][data-product-list-tab]'));
      const panels = Array.from(root.querySelectorAll('.product-list__tab-panel'));
      const viewAll = root.querySelector('.product-list__header-cta a[href]');
      const viewAllBottom = root.querySelector('[data-product-list-view-all]');
      const sectionId = root.dataset.sectionId;

      const tabpanels = root.querySelector('[data-product-list-tabpanels]');

      function loadPanel(panel, handle) {
        if (!handle || !sectionId) return;
        panel.setAttribute('aria-busy', 'true');
        fetch('/collections/' + handle + '?section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            const scrollY = window.scrollY;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetched = doc.querySelector(
              '.product-list__tab-panel[data-collection-handle="' + handle + '"]'
            );
            if (fetched) panel.innerHTML = fetched.innerHTML;
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            panel.dataset.loaded = 'true';
            panel.removeAttribute('aria-busy');
            if (tabpanels) tabpanels.style.minHeight = '';
          })
          .catch(function () {
            panel.removeAttribute('aria-busy');
            if (tabpanels) tabpanels.style.minHeight = '';
          });
      }

      function activate(index) {
        const tab = tabs[index];
        const panel = panels[index];
        if (tabpanels) tabpanels.style.minHeight = tabpanels.offsetHeight + 'px';
        tabs.forEach(function (t, i) {
          const selected = i === index;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
          if (panels[i]) panels[i].hidden = !selected;
        });
        if (viewAll && tab && tab.dataset.collectionUrl) {
          viewAll.setAttribute('href', tab.dataset.collectionUrl);
        }
        if (viewAllBottom && tab && tab.dataset.collectionUrl) {
          viewAllBottom.setAttribute('href', tab.dataset.collectionUrl);
        }
        if (panel && panel.dataset.loaded !== 'true' && tab) {
          loadPanel(panel, tab.dataset.collectionHandle);
        } else if (tabpanels) {
          tabpanels.style.minHeight = '';
        }
      }

      tablist.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-product-list-tab]');
        if (!btn || !tablist.contains(btn)) return;
        const idx = tabs.indexOf(btn);
        if (idx === -1) return;
        activate(idx);
      });

      tablist.addEventListener('keydown', function (e) {
        const current = tabs.findIndex(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        });
        if (current === -1) return;
        let next = current;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          next = Math.min(current + 1, tabs.length - 1);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          next = Math.max(current - 1, 0);
        } else if (e.key === 'Home') {
          next = 0;
        } else if (e.key === 'End') {
          next = tabs.length - 1;
        } else {
          return;
        }
        e.preventDefault();
        activate(next);
        tabs[next].focus();
      });
    }

    document.querySelectorAll('[data-product-list-tabs]').forEach(initProductListTabs);
    document.addEventListener('shopify:section:load', function (ev) {
      if (!(ev.target instanceof HTMLElement)) return;
      const root = ev.target.querySelector('[data-product-list-tabs]');
      if (root) initProductListTabs(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text-banner"] && !Shopify.designMode) return;
  try {
    
  class VideoTextBannerPause extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.video-text-banner__pause');
      if (!this.button) return;

      this.pauseIcon = this.querySelector('.video-text-banner__pause-icon--pause');
      this.playIcon = this.querySelector('.video-text-banner__pause-icon--play');

      this.onClick = this.onClick.bind(this);
      this.syncState = this.syncState.bind(this);

      this.button.addEventListener('click', this.onClick);

      // Keep the icon in sync with whatever drives playback (autoplay, loop end, etc.)
      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', this.syncState);
        video.addEventListener('pause', this.syncState);
      });

      this.syncState();
    }

    // The visible <video> (mobile/desktop swap hides one with display:none → no offsetParent).
    get activeVideo() {
      const videos = Array.from(this.querySelectorAll('video'));
      return videos.find((v) => v.offsetParent !== null) || videos[0] || null;
    }

    onClick() {
      const video = this.activeVideo;
      if (!video) return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    syncState() {
      const video = this.activeVideo;
      const paused = video ? video.paused : true;
      this.button.setAttribute('aria-pressed', String(!paused));
      if (this.pauseIcon) this.pauseIcon.classList.toggle('hidden', paused);
      if (this.playIcon) this.playIcon.classList.toggle('hidden', !paused);
    }
  }

  if (!customElements.get('video-text-banner-pause')) {
    customElements.define('video-text-banner-pause', VideoTextBannerPause);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waterproof"] && !Shopify.designMode) return;
  try {
    
  class WaterproofPause extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.waterproof__pause');
      if (!this.button) return;

      this.pauseIcon = this.querySelector('.waterproof__pause-icon--pause');
      this.playIcon = this.querySelector('.waterproof__pause-icon--play');

      this.onClick = this.onClick.bind(this);
      this.syncState = this.syncState.bind(this);

      this.button.addEventListener('click', this.onClick);

      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', this.syncState);
        video.addEventListener('pause', this.syncState);
      });

      this.syncState();
    }

    get activeVideo() {
      const videos = Array.from(this.querySelectorAll('video'));
      return videos.find((v) => v.offsetParent !== null) || videos[0] || null;
    }

    onClick() {
      const video = this.activeVideo;
      if (!video) return;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    syncState() {
      const video = this.activeVideo;
      const paused = video ? video.paused : true;
      this.button.setAttribute('aria-pressed', String(!paused));
      if (this.pauseIcon) this.pauseIcon.classList.toggle('hidden', paused);
      if (this.playIcon) this.playIcon.classList.toggle('hidden', !paused);
    }
  }

  if (!customElements.get('waterproof-pause')) {
    customElements.define('waterproof-pause', WaterproofPause);
  }

  } catch(e) { console.error(e); }
})();
})();
